var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80031 7.9C3.53031 7.31 2.80031 6.7 2.80031 5.75C2.80031 4.66 3.81031 3.9 5.50031 3.9C7.28031 3.9 7.94031 4.75 8.00031 6H10.2103C10.1403 4.28 9.09031 2.7 7.00031 2.19V0H4.00031V2.16C2.06031 2.58 0.500312 3.84 0.500312 5.77C0.500312 8.08 2.41031 9.23 5.20031 9.9C7.70031 10.5 8.20031 11.38 8.20031 12.31C8.20031 13 7.71031 14.1 5.50031 14.1C3.44031 14.1 2.63031 13.18 2.52031 12H0.320312C0.440312 14.19 2.08031 15.42 4.00031 15.83V18H7.00031V15.85C8.95031 15.48 10.5003 14.35 10.5003 12.3C10.5003 9.46 8.07031 8.49 5.80031 7.9Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/IconDollar.8261f108.svg";
export { ForwardRef as ReactComponent };